export default __webpack_public_path__ + "static/media/gold.e5d01de0.svg";